export default __webpack_public_path__ + "static/media/Medium.db365c16.ttf";